import { $ } from '@/Engine/state';
import { getShelveCNCHardCollisionForObject } from '@/Engine/eventHandlers/libs/markCollision';
import { getMaxIndexSection, getParentSection } from '@/Engine/eventHandlers/libs/getHardSection';

function replaceSubstringAfterChar(str, char, newStr) {
    const index = str.indexOf(char);
    if (index !== -1) {
        const beforeChar = str.slice(0, index + 2);
        return beforeChar + newStr;
    }
    return str;
}
export async function chpuChangeModel(valueChangeChpu, add: boolean, newName, parent?: null) {
    const obj = $.selectedModel?.userData.parent;
    const model = await $.modelCache?.getOrUploadModelByName(newName);
    if (!model) return;

    $.isChangeChpu = valueChangeChpu;
    obj.changeModel(model, add, parent);
}
export async function chpuHardChangeModel() {
    const obj = $.selectedModel?.userData.parent;
    const objs = getShelveCNCHardCollisionForObject(obj);
    const parentSection = getParentSection(objs);
    const indexS = getMaxIndexSection(parentSection);
    const newName = replaceSubstringAfterChar(obj.model.name, '_s', +indexS + 1);

    if (!parentSection) {
        await chpuChangeModel(null, false, newName, null);
    } else if (!$.isChangeChpu && indexS < 3) {
        await chpuChangeModel(parentSection, true, newName, parentSection);
    }
    // getShelveCNCHardCollisionForObject(obj);
}